import React from "react";
import Subscriber from "../../subscriber.class";
import Storage from "../../services/storage.service";
// import Events from "../../services/events.service";
import Forms from "../../services/forms.service";
import MapService from "../../services/maps.service";

class MapContainer extends Subscriber {
	timer;
	map = null;
	marker = null;
	mapConfig;
	options;

	using_current_location = true;

	state = {
		selectedLocation: "",
		fetchingCurrentPosition: true,
		search_enabled: false,
		clearVisible: false,
		delivery_address : null
	};

	constructor() {
		super();
		this.mapRef = React.createRef();
		this.searchRef = React.createRef();
	}

	renderMap = () => {
		if (this.props.id) {
			let map = MapService.createMap(this.props.id, this.mapRef, this.props);
			if (map) {
				if (!this.props.freeze) {
					// MapService.addSearch(this.searchRef, this.props.id, true);
					if (this.searchRef.current) {
						MapService.addSearch(this.searchRef, this.props.id, true);
				}
				}
				if (this.props.bubble) {
					MapService.addBubble(this.props.id, this.props.bubble);
				}
			}
		}
	};

	componentDidMount() {
		window.mapLoaded = () => {};
		let val = this.props.delivery_address;
		this.setState({
			clearVisible: val ? true : false,
			delivery_address : this.props.delivery_address
		});

		this.subscriptions.push(
			Storage.get_obsrv("maps_loaded").subscribe((data) => {
				if (data) {
					this.renderMap();
				}
				if (this.searchRef.current) {
					MapService.addSearch(this.searchRef, this.props.id, true);
			}
			})
		);
		Storage.set("addressStepNumber", 1, true )
	}
	shouldComponentUpdate(prevProps) {
				if (prevProps.delivery_address !== this.state.delivery_address) {
						let val = this.props.delivery_address;
		this.setState({
			clearVisible: val ? true : false,
			delivery_address : this.props.delivery_address
		});
			return true;
		}
		return false;
	}
	change = (event) => {
		let val = Forms.getEventValue(event);
		this.setState({
			clearVisible: val ? true : false,
		});
	};

	clear = () => {
		this.setState({
			clearVisible: false,
		});
		this.props.clear();
	};

	render() {
		let location = this.state.selectedLocation;
		if (!location) {
			location = this.state.fetchingCurrentPosition
				? "Fetching your current location .."
				: "";
		}
		let map = (
			<div className="vmo-map" ref={this.mapRef}>
				Loading map...
			</div>
		);

		return (
			<div className="vmo-map-wrapper">
				<div className="vmo-map-wrapper-area">
						{map}
					<div id="map_search" className="vmo-map-search">
						<div className="vmo-map-searchbox-max">
							<div className="vmo-map-searchbox">
								<div
									className={`vmo-map-searchbox-inner`}
									onChange={(event) => {
										this.change(event);
									}}
								>
										<div className="vmo-map-searchbox-inner-2">
										{this.props.map_search ? (
											this.props.map_search
										) : (
											<input
												type="text"
												id="map_search_box"
												ref={this.searchRef}
												placeholder="Search.."
												onFocus={() => {
													// Events.clicks_on_delivery_map_search_field();
												}}
											/>
										)}
										</div>
									{this.state.clearVisible ? (
										<div className="vmo-field-clear" onClick={this.clear} />
									) : (
										""
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default MapContainer;
